import React from 'react';
import Banner from '../components/banner';
import About from '../components/about';
import WhatWeDo from '../components/WhatWeDo';
import LookingLoan from '../components/looking-loan';
import LoanSteps from '../components/loan-steps';
import LoanCalculator from '../components/loan-calculator';
import LoanFeatures from '../components/loan-features';
// import LatestInsights from '../components/latest-insights';
import EligibilityCriteria from '../components/eligibility-criteria';
import RequiredDocuments from '../components/required-documents';
import TrustCompliance from '../components/trustCompliance';
import WhyChooseUs from '../components/whychoose-us';
// import MonthlyPayment from '../components/monthly-payment';

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <WhatWeDo />
      <WhyChooseUs />     
      <LookingLoan />
      <LoanSteps />
      <LoanCalculator />
      <LoanFeatures />
      <EligibilityCriteria />
      <RequiredDocuments />
      <TrustCompliance />
    </>
  );
};

export default Home;
